const iyfaaoPrice = {

  "BLS1":40,
  "BLS2":40,
  "BLS3":50,
  "BLS4":60,
  "BLS5":70,

  "BLD1":60,
  "BLD2":60,
  "BLD3":70,
  "BLD4":80,
  "BLD5":90,

  "BLG1":80,
  "BLG2":80,
  "BLG3":100,
  "BLG4":100,
  "BLG5":120,


  "JZS1":40,
  "JZS2":40,
  "JZS3":50,
  "JZS4":60,
  "JZS5":70,

  "JZD1":60,
  "JZD2":60,
  "JZD3":70,
  "JZD4":80,
  "JZD5":90,

  "JZG1":80,
  "JZG2":80,
  "JZG3":100,
  "JZG4":100,
  "JZG5":120,


  "CTS1":40,
  "CTS2":40,
  "CTS3":50,
  "CTS4":60,
  "CTS5":70,

  "CTD1":60,
  "CTD2":60,
  "CTD3":70,
  "CTD4":80,
  "CTD5":90,

  "CTG1":80,
  "CTG2":80,
  "CTG3":100,
  "CTG4":100,
  "CTG5":120,


  "OSS1":40,
  "OSS2":40,
  "OSS3":50,
  "OSS4":60,
  "OSS5":70,

  "OSD1":60,
  "OSD2":60,
  "OSD3":70,
  "OSD4":80,
  "OSD5":90,

  "OSG1":80,
  "OSG2":80,
  "OSG3":100,
  "OSG4":100,
  "OSG5":120,


"TEST":0.01,
}

export default iyfaaoPrice;